import React from 'react'

interface ISchemaDiagramProps {
  id: string
}

const SchemaDiagram: React.FC<ISchemaDiagramProps> = () => {
  return (
    <section className={'d-flex'}>
      <div className={'task-schema-diagram'}>
        <img src={'/img/task/schemaDiagram.svg'} width={609} height={1125} alt={'ER-диаграмма'} />
      </div>
    </section>
  )
}

export {SchemaDiagram}
